<template>
  <footer class="bg-dark text-white py-2">
    <div class="container text-center">
      <p class="mb-0">
        &copy; {{ currentYear }} HummingBird Analytics. All rights reserved.
      </p>

      <p class="text-white-50 mt-2 mb-2">
        Collin County Property Tax Appeal Support
      </p>

      <!-- Banded credits section (commented out — replaced by footer links row below)
      <hr class="border-info opacity-50 my-2">
      <p class="fst-italic font-serif text-info small mb-2">
        Functional Interactivity by Christine
        <span class="fs-4 lh-1">&bull;</span>
        Artificial Intelligence Assembly by HummingBird Analytics
      </p>
      <hr class="border-info opacity-50 my-2">
      -->

      <hr class="border-info opacity-50 my-2">

      <p class="fst-italic font-serif text-info small mb-2">
        <router-link :to="{ name: 'Privacy' }" class="text-info text-decoration-none footer-link">
          Privacy Policy
        </router-link>
        <span class="fs-4 lh-1">&bull;</span>
        <router-link :to="{ name: 'Contact' }" class="text-info text-decoration-none footer-link">
          Contact Us
        </router-link>
      </p>

      <hr class="border-info opacity-50 my-2">

      <p class="text-white-50 small mb-1" style="font-size: 0.75rem;">
        HummingBird Analytics provides informational tools only and is not a legal, tax, or appraisal
        service. No guarantee of results is expressed or implied.
      </p>
    </div>
  </footer>
</template>

<script setup>
// Current year for footer
const currentYear = new Date().getFullYear()
</script>

<style scoped>
.font-serif {
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.footer-link:hover {
  color: #fff !important;
  text-decoration: underline !important;
}
</style>
